import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { EMPTY_STRING, inventoryConstants } from "../../../constants";

const TitleToolTip = ({
  title = EMPTY_STRING, // title is what shown in the tooltip menu
  children, // children is what is shown in the component (like span, div, etc) and when hovered then tooltip will be shown
  placement = "bottom",
}) => {
  const id = `${Math.random() * 10}-${title}`;
  let toolTipTitle = title;
  // if title is an array (sku, tag) then convert into jsx
  if (Array.isArray(title) && title.length) {
    toolTipTitle = (
      <>
        {title
          .filter((tag) => tag !== inventoryConstants.CUSTOM_ITEM_TAG) // if passed title is array of tags then filter the tag to not show the custom item tag (this is useful when rendering ProductTagColumn)
          .map((s, index) => (
            <p
              className="sku-wrapper text-nowrap text-start fw-normal m-0"
              key={index}
            >
              {s}
            </p>
          ))}
      </>
    );
  }

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip id={id} className="title-tooltip">
          {toolTipTitle}
        </Tooltip>
      }
    >
      <span>{children}</span>
    </OverlayTrigger>
  );
};

export default TitleToolTip;
